
/**
 * Get key/value mapping of GET parameters in current url
 * https://stackoverflow.com/questions/979975/how-to-get-the-value-from-the-get-parameters#1099670
 * @param qs, string or null
 * @returns Object
 */
export function getQueryParams(qs=null) {
    if (!qs)
        qs = window.location.search;

    qs = qs.split('+').join(' ');

    let params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

export function getHashParams(qs=null) {
    if (!qs)
        qs = window.location.hash;

    qs = qs.split('+').join(' ');

    let params = {},
        tokens,
        re = /[#&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}


/** Convert a single query to component of a hash-url */
export function paramToHash(model, field, value, x, y) {
    let pos = '';
    if (x > 0 || y > 0)
        pos = pos + `.${x}`;
    if (y > 0)
        pos = pos + `.${y}`;
    return `${encodeURIComponent(model)}-${encodeURIComponent(field)}${pos}=${encodeURIComponent(value)}`;
}


/** Convert expert-search columns to url-hash representation
 */
export function columnsToHash(columns) {
    let hashes = [];
    for (let x in columns) {
        for (let y in columns[x]) {
            const item = columns[x][y];
            let pos = '';
            if (x > 0 || y > 0)
                pos = pos + `.${x}`;
            if (y > 0)
                pos = pos + `.${y}`;
            hashes.push(paramToHash(item.model, item.field, item.value, x, y));
        }
    }
    return hashes.join("&")
}

/** Convert a url-hash string to expert-search columns,
    using the supplied widget_types config.
 */
export function hashToColumns(hash, widget_types) {
    const hashes = getHashParams(hash);

    function splitHash(key) {
        const key_parts = key.split(".");

        let pos_x = 0, pos_y = 0;
        if (key_parts.length >= 2)
            pos_x = parseInt(key_parts[1]);
        if (key_parts.length >= 3)
            pos_y = parseInt(key_parts[2]);

        const model_field = key_parts[0].split("-");

        const modeldef = widget_types.find(m => m.model === model_field[0]);
        const fielddef = modeldef.fields.find(f => f.name === model_field[1]);

        return {
            model: model_field[0],
            field: model_field[1],
            pos_x: pos_x,
            pos_y: pos_y,
            value: hashes[key],
            type: fielddef.type,
            flat_field: fielddef.field,
        }
    }

    // determine extent
    let max_x = 1, max_y = 1;
    for (let key in hashes) {
        const item = splitHash(key);
        max_x = Math.max(max_x, item.pos_x);
        max_y = Math.max(max_y, item.pos_y);
    }

    let columns = [];
    for (let key in hashes) {
        const item = splitHash(key);

        while (item.pos_x >= columns.length)
            columns.push([]);

        while (item.pos_y >= columns[item.pos_x].length)
            columns[item.pos_x].push([]);

        columns[item.pos_x][item.pos_y] = {
            model: item.model,
            field: item.field,
            value: item.value,
            type: item.type,
            flat_field: item.flat_field,
        };
    }
    return columns;
}


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/queryParams.js